import styled from "@emotion/styled";
import React from 'react'
import MuiAlert from '@mui/material/Alert'

export const ProgressDiv = styled('div')({
  paddingTop: 70,
  height : "100%",
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});


export const MessageDiv = styled('div')({
  paddingTop: 70,
  height : "100%",
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

export const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});